import { useEffect } from 'react';
import { navigate } from "@reach/router"

const BethanyFireDeptPage = () => {
  useEffect(() => {
    navigate('/solutions/industries/emergency-services/');
  }, []);
  return null;
};

export default BethanyFireDeptPage;